import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const businessesConstants = {
  GET_BUSINESSES_START: "GET_BUSINESSES_START",
  GET_BUSINESSES_SUCCESS: "GET_BUSINESSES_SUCCESS",
  GET_BUSINESSES_ERROR: "GET_BUSINESSES_ERROR"
};

export const getBusinesses = () => {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;

    dispatch({
      type: businessesConstants.GET_BUSINESSES_START
    });

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/workspace/businesses?managerId=${main.accountantUuidSelected}&itemId=${main.companyUuidSelected}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: businessesConstants.GET_BUSINESSES_SUCCESS,
            payload: { data: result.data }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: businessesConstants.GET_BUSINESSES_ERROR,
            payload: err
          });
          reject(err);
        });
    });
  };
};
